export default "__VITE_ASSET__f29c78e1__"